<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">

      <div class="teacher-kq-tab-bar">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="homeLiveTypeName || '日间类型'" name="home"></el-tab-pane>
          <el-tab-pane :label="schoolLiveTypeName || '住宿类型'" name="hostel"></el-tab-pane>
          <el-tab-pane label="全体学生周末返校" name="weekendReturn"></el-tab-pane>
          <el-tab-pane label="请假返校" name="leaveReturn"></el-tab-pane>
        </el-tabs>
      </div>

      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="getSearchList()"></toolbar>

      <!--列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- <el-table-column type="index" width="80"></el-table-column> -->
        <el-table-column prop="DepartmentName" label="部门" min-width="120"></el-table-column>
        <el-table-column prop="KaoqinDate" label="日期" min-width="120"></el-table-column>
        <el-table-column prop="LateCount" :label="getCountLabel()" min-width="100"></el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="showuserKqtData(scope.row)" type="text">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- 详情弹窗 -->
      <el-dialog :title="getDialogTitle()" :visible.sync="detailDialogVisible" width="40%"
        :close-on-click-modal="false" @close="onDetailDialogClose">
        <el-table :data="lateDetails" style="width: 100%" v-loading="detailLoading" max-height="420" class="custom-tbl">
          <el-table-column prop="UserName" label="用户名" min-width="90"></el-table-column>
          <el-table-column prop="DepartmentName" label="部门" min-width="100"></el-table-column>
          <el-table-column prop="LateCount" :label="getAbnormalTypeLabel() + '次数'" width="100"></el-table-column>
          <el-table-column :prop="'LateDetails'" :label="getAbnormalTypeLabel() + '详情'" min-width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.LateDetails && scope.row.LateDetails.length > 0">
                <div v-for="(detail, index) in scope.row.LateDetails" :key="index" class="late-detail-item">
                  <span> {{ getTimeOnly(detail.RegTime) }} - {{ getStatusText(detail.RegStatus) }}</span>
                </div>
              </div>
              <span v-else class="no-detail">无详情</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="detail-pagination">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page.sync="detailPage"
            :page-size="detailPageSize"
            :total="lateDetailsTotal"
            @current-change="handleDetailPageChange"
          />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 请假返校异常独立弹窗 -->
      <el-dialog :title="getLeaveReturnDialogTitle()" :visible.sync="leaveReturnDialogVisible" width="50%"
        :close-on-click-modal="false" @close="onLeaveReturnDialogClose">
        <el-table :data="leaveReturnDetails" style="width: 100%" v-loading="detailLoading" max-height="420" class="custom-tbl">
          <el-table-column prop="UserName" label="学生姓名" min-width="90"></el-table-column>
          <el-table-column prop="DepartmentName" label="部门" min-width="100"></el-table-column>
          <el-table-column prop="RemindDate" label="请假日期" min-width="120"></el-table-column>
          <el-table-column prop="AttendanceQueryEndTime" label="结束时间" min-width="140"></el-table-column>
        </el-table>
        <div class="detail-pagination">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page.sync="leaveReturnPage"
            :page-size="detailPageSize"
            :total="leaveReturnDetailsTotal"
            @current-change="handleLeaveReturnPageChange"
          />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="leaveReturnDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getInSchoolSummaryByDate, getInSchoolLateDetail, getHostelLateSummaryByDate, getHostelLateDetail, getWeekendLateInSummary, getWeekendLateInDetail, getLeaveStudentReturnExceptionSummary, getLeaveStudentReturnExceptionDetail, exportInSchoolLateSummaryAndDetail, exportHostelLateSummaryAndDetail, exportWeekendLateInSummaryAndDetail, exportLeaveStudentReturnExceptionSummaryAndDetail, exportUserMonthDetail } from '../../api/modules/attendance';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import { fetchStudentLiveTypesByDeptId, liveTypeNameOf } from '../../utils/studentLiveType';

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      activeName: "home",
      liveTypeList: [],
      homeLiveTypeName: '',
      schoolLiveTypeName: '',
      filters: {
      },
      searchList: [
        {
          label: '开始日期',
          key: 'startDate',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
        {
          label: '进出类型',
          key: 'inOrOut',
          type: 'select',
          init: true,
          options: [
            { label: '进', value: 'in' },
            { label: '出', value: 'out' }
          ]
        }
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",

      dialogVisible: false,
      currentDate: "",
      // 新增详情弹窗相关数据（接口分页）
      detailDialogVisible: false,
      lateDetails: [],
      lateDetailsTotal: 0,
      detailPage: 1,
      detailPageSize: 10,
      currentUser: null,
      detailLoading: false, // 添加加载状态

      // 新增请假返校异常相关数据（接口分页）
      leaveReturnDialogVisible: false,
      leaveReturnDetails: [],
      leaveReturnDetailsTotal: 0,
      leaveReturnPage: 1,
      exportLoading: false, // 导出加载状态
    };
  },
  methods: {
    // 根据当前标签页/进出类型获取计数标签
    getCountLabel() {
      if (this.activeName === 'leaveReturn') {
        return '返校异常人数';
      }
      if (this.activeName === 'weekendReturn') {
        return '迟到人数';
      }
      if (this.filters.inOrOut === 'out') {
        return '早退人数';
      }
      return '迟到人数';
    },
    getAbnormalTypeLabel() {
      if (this.activeName === 'weekendReturn') {
        return '迟到';
      }
      return this.filters.inOrOut === 'out' ? '早退' : '迟到';
    },
    // 根据当前标签页动态获取搜索列表
    getSearchList() {
      // 基础搜索列表
      const baseSearchList = [
        {
          label: '开始日期',
          key: 'startDate',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        }
      ];

      // 只有非周末返校标签页才显示进出类型选择器
      if (this.activeName !== 'weekendReturn' && this.activeName !== 'leaveReturn') {
        baseSearchList.push({
          label: '进出类型',
          key: 'inOrOut',
          type: 'select',
          init: true,
          options: [
            { label: '进', value: 'in' },
            { label: '出', value: 'out' }
          ]
        });
      }

      return baseSearchList;
    },

    handleClick(tab, event) {
      this.page = 1;
      this.handleQuery();
    },
    getStatusColor(status) {
      if (status != "normal") {
        return 'red';
      }
      return '';
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.loadLiveTypeNames();
      this.handleQuery();
    },
    async loadLiveTypeNames() {
      this.liveTypeList = await fetchStudentLiveTypesByDeptId(this.DepartmentId);
      this.homeLiveTypeName = liveTypeNameOf(this.liveTypeList, 'live_home');
      this.schoolLiveTypeName = liveTypeNameOf(this.liveTypeList, 'live_school');
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      this.listLoading = true;

      let apiMethod;
      if (this.activeName === 'hostel') {
        apiMethod = getHostelLateSummaryByDate;
      } else if (this.activeName === 'weekendReturn') {
        apiMethod = getWeekendLateInSummary;
      } else if (this.activeName === 'leaveReturn') {
        apiMethod = getLeaveStudentReturnExceptionSummary;
      } else {
        apiMethod = getInSchoolSummaryByDate;
      }
      apiMethod(para).then((res) => {
        // this.total = res.data.response.dataCount;
        // this.users = res.data.response.data;
        // this.listLoading = false;
        if (res.data.success && res.data.response) {
          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
          this.listLoading = false;
        } else {
          this.users = [];
          this.total = 0;
          this.listLoading = false;
          const message = res.data.msg || "获取列表数据失败";
          this.$message.warning(message);
        }
      });
    },
    // 获取弹窗标题
    getDialogTitle() {
      return `${this.getAbnormalTypeLabel()}学生列表 - ${this.currentUser ? this.currentUser.KaoqinDate : ''}`;
    },
    // 获取请假返校异常弹窗标题
    getLeaveReturnDialogTitle() {
      return `请假返校异常学生列表 - ${this.currentUser ? this.currentUser.KaoqinDate : ''}`;
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        late: '迟到',
        equit: '早退',
        normal: '正常',
      };
      return statusMap[status] || status;
    },

    // 提取时间部分（去掉年月日）
    getTimeOnly(dateTime) {
      if (!dateTime) return '';
      // 假设时间格式为 '2023-12-25 08:30:45'
      const timePart = dateTime.split(' ')[1];
      return timePart || dateTime;
    },

    // 查看迟到/异常详情
    showuserKqtData(row) {
      this.currentUser = row;
      // 根据标签页类型选择不同的弹窗
      if (this.activeName === 'leaveReturn') {
        this.leaveReturnPage = 1;
        this.leaveReturnDialogVisible = true;
        this.loadLeaveReturnDetails(row);
      } else {
        this.detailPage = 1;
        this.detailDialogVisible = true;
        this.loadLateDetails(row);
      }
    },

    handleDetailPageChange(val) {
      this.detailPage = val;
      if (this.currentUser) {
        this.loadLateDetails(this.currentUser);
      }
    },
    handleLeaveReturnPageChange(val) {
      this.leaveReturnPage = val;
      if (this.currentUser) {
        this.loadLeaveReturnDetails(this.currentUser);
      }
    },
    onDetailDialogClose() {
      this.lateDetails = [];
      this.lateDetailsTotal = 0;
      this.detailPage = 1;
    },
    onLeaveReturnDialogClose() {
      this.leaveReturnDetails = [];
      this.leaveReturnDetailsTotal = 0;
      this.leaveReturnPage = 1;
    },

    // 调用接口加载迟到/晚归详情（服务端分页）。最后更新：2026-08-31
    loadLateDetails(row) {
      this.detailLoading = true;

      const params = {
        date: row.KaoqinDate,
        departmentId: this.DepartmentId || "",
        inOrOut: this.filters.inOrOut || "in",
        page: this.detailPage,
        intPageSize: this.detailPageSize
      };

      let apiMethod;
      if (this.activeName === 'hostel') {
        apiMethod = getHostelLateDetail;
      } else if (this.activeName === 'weekendReturn') {
        apiMethod = getWeekendLateInDetail;
      } else {
        apiMethod = getInSchoolLateDetail;
      }

      apiMethod(params).then((res) => {
        if (res.data && res.data.success && res.data.response) {
          this.lateDetails = res.data.response.data || [];
          this.lateDetailsTotal = res.data.response.dataCount || 0;
        } else {
          this.lateDetails = [];
          this.lateDetailsTotal = 0;
          this.$message.warning(res.data.msg || "获取详情数据失败");
        }
      }).catch((error) => {
        console.error('调用接口失败:', error);
        this.$message.error('网络错误，请稍后重试');
        this.lateDetails = [];
        this.lateDetailsTotal = 0;
      }).finally(() => {
        this.detailLoading = false;
      });
    },

    // 调用接口加载请假返校异常详情（服务端分页）。最后更新：2026-08-31
    loadLeaveReturnDetails(row) {
      this.detailLoading = true;

      const params = {
        date: row.KaoqinDate,
        departmentId: this.DepartmentId || "",
        page: this.leaveReturnPage,
        intPageSize: this.detailPageSize
      };

      getLeaveStudentReturnExceptionDetail(params).then((res) => {
        if (res.data && res.data.success && res.data.response) {
          this.leaveReturnDetails = res.data.response.data || [];
          this.leaveReturnDetailsTotal = res.data.response.dataCount || 0;
        } else {
          this.leaveReturnDetails = [];
          this.leaveReturnDetailsTotal = 0;
          this.$message.warning(res.data.msg || "获取请假返校异常数据失败");
        }
      }).catch((error) => {
        console.error('调用请假返校异常接口失败:', error);
        this.$message.error('网络错误，请稍后重试');
        this.leaveReturnDetails = [];
        this.leaveReturnDetailsTotal = 0;
      }).finally(() => {
        this.detailLoading = false;
      });
    },

    // 修改exportExcel方法
    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters
        };

        // 根据标签页类型选择不同的导出接口和文件名
        let exportMethod;
        let fileName;

        switch (this.activeName) {
          case 'hostel':
            exportMethod = exportHostelLateSummaryAndDetail;
            fileName = (this.schoolLiveTypeName || '住宿类型') + "迟到汇总报表";
            break;
          case 'weekendReturn':
            exportMethod = exportWeekendLateInSummaryAndDetail;
            fileName = "周末返校汇总报表";
            break;
          case 'leaveReturn':
            exportMethod = exportLeaveStudentReturnExceptionSummaryAndDetail;
            fileName = "请假返校异常汇总报表";
            break;
          default: // home
            exportMethod = exportInSchoolLateSummaryAndDetail;
            fileName = (this.homeLiveTypeName || '日间类型') + "迟到汇总报表";
            break;
        }

        const response = await exportMethod(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }

        // 处理导出数据
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
        this.$message({
          message: "导出失败",
          type: "error",
        });
      }
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.detail-pagination {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.late-detail-item {
  line-height: 1.6;
}

.no-detail {
  color: #c0c4cc;
}
</style>
<style>
.user-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.user-info p {
  margin: 5px 0;
}

.empty-data {
  text-align: center;
  padding: 40px;
  color: #909399;
}

.column-select-container {
  display: flex;
  justify-content: space-between;
}

.column-section {
  width: 48%;
}
</style>